import { render, staticRenderFns } from "./ImoFalFormsHeader.vue?vue&type=template&id=24b9be76"
import script from "./ImoFalFormsHeader.vue?vue&type=script&lang=js"
export * from "./ImoFalFormsHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports